<template>
  <div class="sc-message flex flex-col min-w-0" :class="direction">
    <div class="sc-message--content sent carousel flex">
      <!---->
      <div
        class="sc-message--file sc-message-bubble border-solid border subpixel-antialiased"
        :class="direction"
        :style="styles"
      >
        <div class="sc-message--file-name flex items-center justify-between my-1.5 mx-2.5 text-center text-inherit">
          <paper-clip-icon/>
          <p class="underline w-5/6 leading-tight ml-1">
            form.pdf
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaperClipIcon from '@/assets/images/icons/chat-widget/paperClipIcon.vue'

export default {
  name: 'ChatPreviewFileMessage',

  components: { PaperClipIcon },

  props: {
    themeConfig: {
      type: Object,
      required: true
    },
    direction: {
      type: String,
      default: 'sent'
    }
  },

  computed: {
    styles() {
      const colors = this.direction === 'sent' ? this.themeConfig.sentMessage.file : this.themeConfig.receivedMessage.file
      return {
        color: colors.text,
        backgroundColor: colors.bg,
        borderColor: colors.border
      }
    }
  }
}
</script>
